import {adventure, award01, award02, award03, award05,award04, diani, hike, safari, ticketing, travel, vacation, wild, zip} from './images.js'

export const wines = [
  {
    title: 'Abardare Ranges Hike and Tour',
    price: '$56',
    tags: 'Take a hike through the abadare ranges in Nyandarua County from as low as $56.',
    image: safari
  },
  {
    title: 'Mombasa Sand Beaches',
    price: '$31',
    tags: 'Have your journey to Mombasa best sand beaches for three days and 2 nights from as low as $150.',
    image: diani
  },
  {
    title: 'Chalbi desert and Northern Kenya Tour',
    price: '$200',
    tags: 'Visit the cradle of mankind, experience the sandy desert vastness and the lake in the middle of a desert in Northern Kenya from as low as USD 200.',
    image: vacation
  },
  {
    title: 'Hells Gate hike and tour, Naivasha',
    price: '$30',
    tags: 'Get guided through the fabulous and amazing gourges of Hells gate park in Naivasha, for only USD 30. Hike through the valleys, and the rocks for the best experience. It is better with a group of more than one.',
    image: adventure
  },
  {
    title: '3 Days Mount Kenya Park',
    price: '$100',
    tags: 'Explore the vast Mt Kenya in a total of three days with colleagues, in an unforgettable experience to the peak. Free photography and snacks',
    image: hike
  },
  {
    title: 'Mara-Serengeti Park Visit',
    price: '$100',
    tags: 'Travel and camp at Serengeti Mara river and national reserve for 2 days and one night to view the great migration this year coming in early in June. Book as early as now.',
    image: wild
  }
];

export const cocktails = [
  {
    title: 'Sychelles in the main place in the world',
    price: '$44',
    tags: 'Feel the heat under the sunscreen oiling, travel by boat, experience the dinasours and the whales in the sea for 39 hours straight.',
    image: vacation
  },
  {
    title: 'Serengeti hiking for 4 days',
    price: '$26',
    tags: 'Hking for 2 days in Serengeti mountains and the rivers. The move of the tour for the end of the journiur. It id the best of the world there is.',
    image: adventure
  },
  
];

export const awards = [
  {
    imgUrl: award01,
    title: 'Integrity',
    subtitle: 'We are just as we appear. Our staff uphold utmost integrity in all dealings, with adherence to all set service policies, and all relevant governing laws.',
  },
  {
    imgUrl: award02,
    title: 'Professionalism',
    subtitle: 'Offering professional service is our virtue and goal. We believe all clients deserve a decent, professional service at the time of their convenience.',
  },
  {
    imgUrl: award03,
    title: 'Inclusivity and equality',
    subtitle: 'We believe everyone deserves equal treatment in our services. Our services are inclusive and accommodative, even to minority groups including the old, disabled, and others.',
  },
  
  {
    imgUrl: award04,
    title: 'Hospitality',
    subtitle: 'All our clients are served with utmost kindness, respect and hospitality by all means and at all times. Customer first.',
  },
  
  {
    imgUrl: award05,
    title: 'Hospitality',
    subtitle: 'All our clients are served with utmost kindness, respect and hospitality by all means and at all times. Customer first.',
  },
];


export const packagesFAQs = [
  {
    imgUrl: award01,
    title: 'How to book for a package',
    subtitle: 'To book for any of package or service on this site, you may fill the form below, with description of the service required. Also, navigate to the contact us page to provide more information. You may also contact us directly through phone or email as provided beneath.',
  },
  {
    imgUrl: award02,
    title: 'How long does booking and reservation take?',
    subtitle: 'Once a call or information has been received on our end, it takes less than 24 hours to get back and confirm your planned journey.',
  },
  {
    imgUrl: award03,
    title: 'Do we provide emergency services?',
    subtitle: 'Well, we encourage our clients to plan their journey early enough. However, for emergency travels, we provide VIP services at an extra cost.',
  },
  {
    imgUrl: award05,
    title: 'Can we customize a safari or a package?',
    subtitle: 'Yes, of course. The outlined packages are only to present sample journeys that one can take with us, and highlights current offers. However, you can make the journey whichever way you want it. You can even request for an existing package with changed location, timelines, destination, etc. Live free.',
  },
]


export const services = [
  {
    title: 'Ticketing',
    image: ticketing
  },
  {
    title: 'Safari Tours',
    image: adventure
  },
  {
    title: 'Transfers',
    image: travel
  },
  {
    title: 'Vacation Planning',
    image: vacation
  },
]


export const categories = [
  {
    title: 'Safaris',
    image: wild
  },
  {
    title: 'Day Tours',
    image: zip
  },
  {
    title: 'Adventures',
    image: travel
  },
  {
    title: 'Vacations',
    image: vacation
  },
]


